import { Component, Input, OnInit, inject } from '@angular/core';
import { PatientAttachment } from 'app/core/models/patient-attachment.model';
import { PatientAttachmentsService } from 'app/core/services/patient-attachments.service';
import { AppToastService } from 'app/core/services/app-toast.service';
import { PdfFileService } from 'app/core/services/pdf-file.service';
import { PdfFile } from 'app/core/interfaces/pdf-file';
import { OcrResult } from 'app/core/models/ocr_result.model';
import { NgClass } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { UserRoleName } from 'app/core/enums/user-role-name.enum';
import { PatientAttachmentLlmResultSet } from 'app/core/models/patient-attachment-llm-result-set.model';

@Component({
  selector: 'app-consult-note-ocr-backfill',
  templateUrl: './consult-note-ocr-backfill.component.html',
  styleUrls: ['./consult-note-ocr-backfill.component.scss'],
  imports: [NgClass, NgbTooltip, MatProgressSpinner, FaIconComponent]
})
export class ConsultNoteOcrBackfillComponent implements OnInit {
  private authService = inject(AuthenticationService);
  private patientAttachmentsService = inject(PatientAttachmentsService);
  private pdfFileService = inject(PdfFileService);
  private toastService = inject(AppToastService);

  pdfFile: PdfFile;
  ocrResult: OcrResult;
  llmResultSet: PatientAttachmentLlmResultSet;
  ocrDone: boolean;
  llmSuccess: boolean;
  showOcrButton = false;
  showLlmButton = false;
  annotationsRunning = false;
  llmRunning = false;
  toolTip = "";

  @Input() set patientAttachment(patientAttachment: PatientAttachment) {
    this.ocrResult = patientAttachment.ocrResult;
    this.llmResultSet = patientAttachment.patientAttachmentLlmResultSet;
    this.pdfFile = patientAttachment;
    this.setFlags();
  }

  ngOnInit(): void {
    this.pdfFileService.pdfFileChanged.subscribe((pdfFileChanged) => {
      this.pdfFile = pdfFileChanged.pdfFile;
      this.setFlags();
    });
  }

  onOcrBackfillClick(_$event: Event): void {
    this.annotationsRunning = true;
    this.patientAttachmentsService.backfillOcr(this.pdfFile.id).subscribe({
      next: pa => this.patientAttachmentsService.notifyPatientAttachmentChanged(pa),
      error: () => this.toastService.show('An error occurred.', { cssClass: 'bg-danger-subtle' })
    })
  }

  onLlmRerunClick(_$event: Event): void {
    this.llmRunning = true;
    this.patientAttachmentsService.rerunLlm(this.pdfFile.id).subscribe({
      next: pa => this.patientAttachmentsService.notifyPatientAttachmentChanged(pa),
      error: () => this.toastService.show('An error occurred.', { cssClass: 'bg-danger-subtle' })
    })
  }

  private setFlags(): void {
    this.showOcrButton = !this.ocrResult ||
      (this.ocrResult && this.ocrResult.status !== 'processing' && this.ocrResult.skipAnnotations) ||
      (this.ocrResult && this.ocrResult.status !== 'processing' && this.ocrResult.lastSubmittedAt < this.pdfFile.fileCreatedAt) ||
      (this.ocrResult && this.ocrResult.status === 'failed');
    this.ocrDone = !!this.ocrResult;
    this.showLlmButton = this.ocrDone && this.authService.hasPermissionTo(UserRoleName.viewOcr);
    this.llmSuccess = this.llmResultSet && !this.llmResultSet.partial;
    this.setToolTip();
  }

  private setToolTip(): void {
    if (this.ocrDone) {
      if (!this.ocrResult.skipAnnotations) {
        this.toolTip = "The OCR data is out of date. This may take a few minutes.";
      }
    } else {
      this.toolTip = "The consult note has not been OCR'ed yet. This may take a few minutes.";
    }
  }

}
